import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { FormOptionComponent } from '../../../form-option/form-option.component';
import {
    ApplicationSpecificQuestions,
    OptionItem,
    Questions,
    QuestionAnswers,
} from 'matchmaking/models';
import { FormTextareaInputComponent } from '../form-textarea-input/form-textarea-input.component';
import { MatchmakingTranslateService } from 'matchmaking/services';

@Component({
    selector: 'matchmaking-dynamic-question',
    imports: [FormOptionComponent, FormTextareaInputComponent],
    templateUrl: './dynamic-question.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dynamic-question.component.scss'
})
export class DynamicQuestionComponent {
    translateService = inject(MatchmakingTranslateService);
    questions = input.required<ApplicationSpecificQuestions>();
    selectedQuestions = input.required<Questions>();
    updateTextareaInputAnswer = output<string>();
    updateQuestionAnswer = output<{
        question: QuestionAnswers;
        value: string;
    }>();

    translations = computed(() => this.translateService.translations());

    setQuestion1(option: OptionItem) {
        this.updateQuestionAnswer.emit({ question: 'question1', value: option.title });
    }

    setQuestion2(option: OptionItem) {
        this.updateQuestionAnswer.emit({ question: 'question2', value: option.title });
    }

    setQuestion3(option: OptionItem) {
        this.updateQuestionAnswer.emit({ question: 'question3', value: option.title });
    }

    setQuestion4(option: OptionItem) {
        this.updateQuestionAnswer.emit({ question: 'question4', value: option.title });
    }

    setQuestion5(option: OptionItem) {
        this.updateQuestionAnswer.emit({ question: 'question5', value: option.title });
    }

    setQuestion6(option: string) {
        this.updateQuestionAnswer.emit({ question: 'question6', value: option });
    }

    optionIsSelected(option: OptionItem, selectedOption: string) {
        if (option.title === selectedOption) {
            return true;
        }

        if (this.translateService.getTranslation(option.title) === selectedOption) {
            return true;
        }

        return false;
    }
}
